import { motion } from "framer-motion";

const chapters = [
  { n: "01", title: "Listen", body: "We begin with your context, priorities and the people closest to the work." },
  { n: "02", title: "Understand", body: "We gather evidence through observation, conversation and existing school data." },
  { n: "03", title: "Make it practical", body: "You receive clear priorities, usable strategies and a realistic route forward." },
  { n: "04", title: "Build momentum", body: "Training, coaching and review help change take root and remain sustainable." },
];

const ease = [0.16, 1, 0.3, 1];

export const Manifesto = () => (
  <section id="approach" className="relative py-24 md:py-36" data-testid="manifesto">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="mb-14 md:mb-20 max-w-2xl">
        <p className="text-xs tracking-[0.22em] uppercase font-semibold text-terra mb-5">Our approach to whole school support</p>
        <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight">
          From <span className="italic text-terra">insight</span> into action.
        </h2>
      </div>

      <div className="divide-y divide-ink/10 border-t border-ink/10">
        {chapters.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease, delay: i * 0.05 }}
            className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-10 md:py-14 group"
            data-testid={`manifesto-chapter-${c.n}`}
          >
            <div className="md:col-span-3">
              <span className="font-serif text-7xl md:text-8xl text-ink/15 group-hover:text-terra transition-colors duration-500">
                {c.n}
              </span>
            </div>
            <h3 className="md:col-span-5 font-serif text-3xl md:text-4xl leading-tight">{c.title}</h3>
            <p className="md:col-span-4 text-base md:text-lg text-ink/65 leading-relaxed self-center">{c.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
